import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { Logo } from '@/components/ui/Logo';

import { AnimatedLoginBackground } from '@/components/layout/AnimatedLoginBackground';
import { trackEvent } from '@/lib/gtm';
import { Button } from '@/components/ui/Button';

export const AtualizarSenha = () => {
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const navigate = useNavigate();

  // Prevent scrolling on the entire page while on this route
  useEffect(() => {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
          document.body.style.overflow = originalOverflow;
      };
  }, []);

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setErro('');

    const { error } = await supabase.auth.updateUser({
      password: senha
    });

    if (error) {
      setErro(error.message);
      setLoading(false);
    } else {
      trackEvent('password_reset');
      // Senha atualizada com sucesso! Redireciona para o dashboard
      navigate('/dashboard');
    }
  };

  return (
    <AnimatedLoginBackground>
        <div className="flex flex-col items-center justify-center w-full h-full p-4">
            
            <div className="w-full max-w-[420px] max-h-full bg-white/95 backdrop-blur-sm rounded-[1.5rem] shadow-2xl border border-slate-100/80 overflow-y-auto overflow-x-hidden relative transition-all ease-out animate-form-fade-in">
                
                <div className="p-4 sm:p-6 flex flex-col justify-center h-full">
                    <Logo 
                        theme="light" 
                        size="large" 
                        className="mb-4 sm:mb-6 mt-4" 
                        showSubtitle 
                        subtitleText="Defina sua nova senha de acesso." 
                    />

                    <form id="form-redefinir-senha" name="Redefinir Senha" onSubmit={handleUpdate} className="space-y-4">
                        <div className="space-y-1.5">
                            <label htmlFor="senha" className="text-sm font-bold text-slate-700">Nova senha</label>
                            <input 
                                id="senha" 
                                type="password" 
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                                disabled={loading}
                                className="w-full px-4 py-2.5 border bg-slate-50 rounded-xl focus:bg-white focus:ring-2 focus:ring-indigo-500 outline-none transition-all placeholder:text-slate-400 font-medium text-sm border-slate-200 focus:border-indigo-500 disabled:opacity-70 disabled:cursor-not-allowed"
                                placeholder="Sua nova senha"
                                required
                                minLength={6}
                            />
                        </div>
                        
                        {erro && (
                            <div className="text-red-700 text-sm bg-red-50 p-3 rounded-xl border border-red-100 font-medium animate-in fade-in slide-in-from-top-1 text-center">
                                {erro}
                            </div>
                        )}

                        <Button 
                            type="submit" 
                            fullWidth 
                            loading={loading} 
                            disabled={loading} 
                            className="py-2.5 text-sm font-bold shadow-lg shadow-indigo-600/20 rounded-xl mt-2"
                        >
                            {loading ? 'Atualizando...' : 'Atualizar senha'}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    </AnimatedLoginBackground>
  );
};
